import React from 'react';
import styles from './PaginationIndicators.module.css';

interface PaginationIndicatorsProps {
  currentPage: number;
  totalPage: number;
}

export const PaginationIndicators: React.FC<PaginationIndicatorsProps> = ({
  currentPage,
  totalPage,
}) => {
  if (totalPage <= 1) {
    return null;
  }

  return (
    <div className={styles.indicatorsContainer}>
      {Array.from({ length: totalPage }, (_, index) => {
        const pageNumber = index + 1;
        const isActive = pageNumber === currentPage;

        return (
          <div
            key={pageNumber}
            className={`${styles.indicator} ${
              isActive ? styles.active : styles.inactive
            }`}
          />
        );
      })}
    </div>
  );
};
